import React, {
  Fragment,
  useCallback,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import leftLinePng from 'src/asset/images/heading-left-line.png';
import { Spin, Radio, Pagination } from 'antd';
import { TitleGrey } from 'src/shared/color-variables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faTableCells } from '@fortawesome/free-solid-svg-icons';
import { VIEW_MODES } from './Constants';
import BookItem from './BookItem';
import { PaginationWrapper } from './Styled';

const Wrapper = styled.div`
  padding: 20px;
`;

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BookListGridContent = styled.div`
  margin-top: 20px;
`;

export const BookListContent = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContentWrapper = styled.div`
  margin-top: 20px;
`;

export const ToolBox = styled.div`
  margin-top: 20px;
`;

export const EmptyDataPlaceholder = styled.div`
  font-size: 16px;
  border: 1px solid var(--border-grey);
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  margin-top: 24px;
  background-color: var(--background-light-orange);
`;

export const Title = styled.div`
  font-size: 24px;
  color: ${TitleGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  text-align: center;

  /* ::before,
  ::after {
    content: '';
    display: block;
    width: 58px;
    height: 6px;
    background-image: url(${leftLinePng});
  } */

  ::after {
    transform: rotate(180deg);
  }
`;

const getGridClassByWidth = (width) => {
  if (width >= 900) {
    return 'col-span-2';
  }
  if (width >= 640) {
    return 'col-span-4';
  }

  return 'col-span-12';
};

function BookList({
  bookList = [],
  isLoading,
  total,
  className = '',
  currentPage,
  pageSize,
  onPageChange,
  initialViewMode = VIEW_MODES.grid,
  shouldShowViewMode = true,
}) {
  const [viewMode, setViewMode] = useState(initialViewMode);
  const [itemGridClass, setItemGridClass] = useState();
  const ref = useRef(null);

  const handleScreenWidth = useCallback((width) => {
    if (width < 640) {
      setViewMode(VIEW_MODES.list);
    } else {
      setItemGridClass(getGridClassByWidth(width));
    }
  }, []);

  const handleChangeViewMode = useCallback((mode) => {
    setViewMode(mode);
    setItemGridClass(getGridClassByWidth(ref.current.offsetWidth));
  }, []);

  const renderBookListContentView = useCallback(
    () => (
      <>
        {viewMode === VIEW_MODES.grid ? (
          <BookListGridContent className="grid grid-cols-12 gap-x-[10px] gap-y-[20px]">
            {bookList.map((book) => (
              <BookItem
                className={itemGridClass}
                book={book}
                viewMode={viewMode}
              />
            ))}
          </BookListGridContent>
        ) : (
          <BookListContent>
            {bookList.map((book) => (
              <BookItem book={book} viewMode={viewMode} />
            ))}
          </BookListContent>
        )}
        <PaginationWrapper>
          <Pagination
            defaultCurrent={currentPage}
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </PaginationWrapper>
      </>
    ),
    [
      bookList,
      currentPage,
      pageSize,
      total,
      onPageChange,
      itemGridClass,
      viewMode,
    ]
  );

  useLayoutEffect(() => {
    handleScreenWidth(ref.current.offsetWidth);
  }, []);

  return (
    <Wrapper ref={ref} className={className}>
      {isLoading ? (
        <SpinWrapper>
          <Spin size="large" />
        </SpinWrapper>
      ) : (
        <ContentWrapper>
          <Title>Tìm được {total} tài liệu</Title>
          {bookList.length ? (
            <>
              <ToolBox>
                {shouldShowViewMode ? (
                  <Radio.Group
                    value={viewMode}
                    onChange={(e) => handleChangeViewMode(e.target.value)}
                  >
                    <Radio.Button value={VIEW_MODES.grid}>
                      <FontAwesomeIcon icon={faTableCells} />
                    </Radio.Button>
                    <Radio.Button value={VIEW_MODES.list}>
                      <FontAwesomeIcon icon={faList} />
                    </Radio.Button>
                  </Radio.Group>
                ) : (
                  ''
                )}
              </ToolBox>
              {renderBookListContentView()}
            </>
          ) : (
            <EmptyDataPlaceholder>Không tìm thấy tài liệu</EmptyDataPlaceholder>
          )}
        </ContentWrapper>
      )}
    </Wrapper>
  );
}

export default BookList;
